import { SONNET_4_6_MODEL, ThinkingModeEffortLevel } from "./types";

const ADAPTIVE_THINKING_MODELS: ReadonlySet<string> = new Set([SONNET_4_6_MODEL.id]);

export const supportsAdaptiveThinking = (model: string): boolean =>
  ADAPTIVE_THINKING_MODELS.has(model);

export const buildAdaptiveThinkingParams = (params: {
  model: string;
  effort?: ThinkingModeEffortLevel;
  budgetTokens?: number;
}): { effort?: ThinkingModeEffortLevel } | { budgetTokens?: number } => {
  if (supportsAdaptiveThinking(params.model)) {
    return { effort: params.effort };
  }
  return { budgetTokens: params.budgetTokens };
};
